import React, { Component } from 'react';
import './App.css';
import ScreenContext from './ScreenContext';
import img_elTelegram from './images/SocialLinks_elTelegram_237495.png';
import img_elTwiter from './images/SocialLinks_elTwiter_1043157.png';
import img_elFacebook from './images/SocialLinks_elFacebook_978545.png';

export default class SocialLinks extends Component {

  static contextType = ScreenContext;

  // This component doesn't use any properties

  constructor(props) {
    super(props);
    
    this.state = {
      copyright: (<div>©2022- Made with React Studio by ARFACTORY</div>),
      copyright_plainText: "©2022- Made with React Studio by ARFACTORY",
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  onClick_elTelegram = async () => {
    window.open('https://t.me/+_7pQquge0yZkNDg0', '_blank');
  
  }
  
  
  onClick_elTwiter = async () => {
    window.open('https://twitter.com/mnemosynekey', '_blank');
  
  }
  
  
  onClick_elFacebook = async () => {
    window.open('https://discord.gg/AqdrCJHd9K', '_blank');
  
  }
  
  
  onClick_elCopyright = async () => {
    window.open('https://www.reactstudio.com', '_blank');
  
  }
  
  
  render() {
    
    const style_elBackgroundShape = {
      background: 'rgba(0, 0, 0, 1.000)',
     };
    const style_elTelegram = {
      height: 'auto',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const style_elTwiter = {
      height: 'auto',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const style_elFacebook = {
      height: 'auto',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const style_elCopyright = {
      fontSize: 12.0,
      color: '#fffefe',
      textAlign: 'center',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    // eslint-disable-next-line no-unused-vars
    const style_elCopyright_inner = {
      textAlign: 'center',
     };
    
    return (
      <div className="SocialLinks">
        <div className="background">
          <div className="containerMinHeight elBackgroundShape" style={style_elBackgroundShape} />
        </div>
        
        <div className="foreground">
          <img className="elTelegram" style={style_elTelegram} src={img_elTelegram} alt="" onClick={this.onClick_elTelegram}  />
          <img className="elTwiter" style={style_elTwiter} src={img_elTwiter} alt="" onClick={this.onClick_elTwiter}  />
          <img className="elFacebook" style={style_elFacebook} src={img_elFacebook} alt="" onClick={this.onClick_elFacebook}  />
          <div className="systemFontRegular  elCopyright" style={style_elCopyright} onClick={this.onClick_elCopyright} >
            <div className="bottomAlignedContent">{this.state.copyright}</div>
          </div>
        </div>
      </div>
    )
  }
  
}
